let parentCache = null;
function getOrCacheParentOffset(parent) {
    const el = parent;
    if (parentCache && parentCache.element === parent) {
        return parentCache;
    }
    let absoluteX = 0;
    let absoluteY = 0;
    let current = el;
    while (current && current !== document.body) {
        absoluteX += current.offsetLeft - (current.scrollLeft || 0);
        absoluteY += current.offsetTop - (current.scrollTop || 0);
        current = current.offsetParent;
    }
    parentCache = {
        element: parent,
        absoluteX,
        absoluteY,
        scrollLeft: el.scrollLeft,
        scrollTop: el.scrollTop,
    };
    return parentCache;
}
function getElementAbsolutePosition(element) {
    const el = element;
    const parent = el.parentElement;
    if (!parent) {
        return { x: 0, y: 0, width: 0, height: 0, center: { x: 0, y: 0 } };
    }
    const parentInfo = getOrCacheParentOffset(parent);
    const x = parentInfo.absoluteX + el.offsetLeft;
    const y = parentInfo.absoluteY + el.offsetTop;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    return {
        x,
        y,
        width,
        height,
        center: {
            x: x + width / 2,
            y: y + height / 2,
        },
    };
}
export const isPointBefore = (a, b, tags) => {
    if (tags.length === 0) {
        return a.y < b.y || (a.y === b.y && a.x < b.x);
    }
    const firstTagPos = getElementAbsolutePosition(tags[0]);
    const tagHeight = firstTagPos.height;
    if (a.y < b.y - tagHeight / 2) {
        return true;
    }
    if (a.y > b.y + tagHeight / 2) {
        return false;
    }
    return a.x < b.x;
};
export const normalizePoints = (p1, p2, tags) => {
    if (isPointBefore(p1, p2, tags)) {
        return { startPoint: p1, endPoint: p2 };
    }
    return { startPoint: p2, endPoint: p1 };
};
export const isTagAfterOrAtPoint = (tag, point) => {
    const pos = getElementAbsolutePosition(tag);
    const top = pos.y;
    const bottom = pos.y + pos.height;
    const left = pos.x;
    const right = pos.x + pos.width;
    if (bottom < point.y) {
        return false;
    }
    if (top <= point.y && point.y <= bottom) {
        if (right < point.x) {
            return false;
        }
    }
    return true;
};
export const isTagBeforeOrAtPoint = (tag, point) => {
    const pos = getElementAbsolutePosition(tag);
    const top = pos.y;
    const bottom = pos.y + pos.height;
    const left = pos.x;
    const right = pos.x + pos.width;
    if (top > point.y) {
        return false;
    }
    if (top <= point.y && point.y <= bottom) {
        if (left > point.x) {
            return false;
        }
    }
    return true;
};
export const binarySearchFirstAfterPoint = (tags, startPoint) => {
    let lo = 0;
    let hi = tags.length - 1;
    let result = -1;
    while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        if (isTagAfterOrAtPoint(tags[mid], startPoint)) {
            result = mid;
            hi = mid - 1;
        }
        else {
            lo = mid + 1;
        }
    }
    return result;
};
export const binarySearchLastBeforePoint = (tags, endPoint) => {
    let lo = 0;
    let hi = tags.length - 1;
    let result = -1;
    while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        if (isTagBeforeOrAtPoint(tags[mid], endPoint)) {
            result = mid;
            lo = mid + 1;
        }
        else {
            hi = mid - 1;
        }
    }
    return result;
};
export const getSelectedEmailsByPoints = (container, startPoint, endPoint) => {
    try {
        const tags = Array.from(container.querySelectorAll('.contact-tag'));
        if (tags.length === 0)
            return [];
        const range = normalizePoints(startPoint, endPoint, tags);
        const firstIndex = binarySearchFirstAfterPoint(tags, range.startPoint);
        if (firstIndex === -1)
            return [];
        const lastIndex = binarySearchLastBeforePoint(tags, range.endPoint);
        if (lastIndex === -1)
            return [];
        if (firstIndex > lastIndex)
            return [];
        return tags.slice(firstIndex, lastIndex + 1).map(tag => tag.getAttribute('data'));
    }
    catch (error) {
    }
    finally {
        clearParentCache();
    }
};
export const clearParentCache = () => {
    parentCache = null;
};
